// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-p_fx","advertDetailContactItem__link":"c-p_fy","advertDetailContactItem__stub":"c-p_fz"};